package com.catbit.opinionpoll.inputs.events

sealed interface TextAreaInputEventData {
    data class OnMaxLengthChange(val newMaxLength: Int) : TextAreaInputEventData
}